var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19106_3724)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0.5C3.14497 0.5 0 3.64497 0 7.5C0 11.355 3.14497 14.5 7 14.5C10.855 14.5 14 11.355 14 7.5C14 3.64497 10.855 0.5 7 0.5ZM7.96397 10.0368L7.30455 10.2904L8.06542 6.33391C8.11615 6.13101 8.0147 5.92811 7.86253 5.77595C7.71035 5.6745 7.45672 5.62377 7.30456 5.72522L5.88426 6.53681C5.63064 6.68898 5.52919 6.99334 5.68136 7.24696C5.83353 7.50057 6.13789 7.60203 6.39151 7.44986L6.79731 7.19624L6.03644 11.0005C5.98571 11.2034 6.08716 11.4063 6.23934 11.5078C6.34079 11.6092 6.44223 11.6092 6.59441 11.6092C6.64513 11.6092 6.74658 11.6092 6.79731 11.5585L8.36977 10.8991C8.62339 10.7976 8.77557 10.4425 8.62339 10.1889C8.52194 10.0367 8.21759 9.88456 7.96397 10.0367V10.0368ZM8.11619 4.45555C7.96403 4.557 7.76113 4.65845 7.55823 4.65845C7.35534 4.65845 7.20316 4.60772 7.00026 4.45555C6.89881 4.30339 6.79736 4.10047 6.79736 3.89758C6.79736 3.69469 6.84809 3.49179 7.00026 3.33962C7.15243 3.23817 7.35533 3.13672 7.55823 3.13672C7.76112 3.13672 7.96402 3.18744 8.11619 3.33962C8.21764 3.49178 8.31909 3.69469 8.31909 3.89758C8.31909 4.10047 8.26837 4.30338 8.11619 4.45555Z",
    fill: "#BABABA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19106_3724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyInfoIcon);
export default __webpack_public_path__ + "static/media/grey-info-icon.5461f2f6835e46f33cca4733d2d9fbb4.svg";
export { ForwardRef as ReactComponent };